// extracted by mini-css-extract-plugin
export default {"searchWrapper":"styles_searchWrapper__lFRgA","searchInput":"styles_searchInput__eqFnR"};